module.exports = __webpack_public_path__ + "static/media/12.b7cb549b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/12.png
// module id = 1052
// module chunks = 0